import styled from "styled-components";

export const SrhJumbotron = styled.div`
  background-color: ${props => props.theme.primaryXLight};
  color: ${props => props.theme.black};
  padding: 12px 35px;
  margin: 0;
  margin-top: 20px;
  text-align: center;

  &.breathing-room {
    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: 10px;
  }

  &&& {
    h1 {
      font-size: 42px;
    }
    h2 {
      font-size: 36px;
    }
    h3 {
      margin-top: 0;
      margin-bottom: 4px !important;
      font-size: 24px;
      letter-spacing: 1px;
      text-align: center;
      display: inline-block;
      width: 328px;
    }
  }
  .header-row {
    display: flex;
    div {
      width: 35px;
      font-size: 13px;
      font-weight: bold;
      align-self: flex-end;
    }
  }
  .rightColumn {
    border-left: 1px solid #81b6bb;
  }
  .mainGridPadding {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  .list {
    margin-top: 0;
    margin-bottom: 15px !important;
  }
  .noPadRow {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }
  .bestWorsts {
    text-align: left;
  }
`;

export const BestWorstRow = styled.div`
  position: relative;

  &.breathing-room {
    margin-top: 7px;
  }

  .perc {
    position: absolute;
    top: 0;
    font-size: 13px;
    font-weight: bold;

    @media print {
      line-height: 16px;
    }

    &.breathing-room {
      line-height: 22px;

      @media print {
        line-height: 20px;
      }
    }
  }
`;

export const BestWorstItem = styled.p`
  width: 328px;
  margin: 0;
  margin-left: 35px;
  font-size: 13px;

  @media print {
    line-height: 16px;
  }

  &.breathing-room {
    font-size: 15px;

    @media print {
      line-height: 20px;
    }
  }

  &.insightLandscape {
    width: 460px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Insights/style.js